export var checkMixin = {
  computed: {
    // 审核状态样式计算
    checkStyle() {
      return (status) => {
        return status === "0" ? "info" : status === "1" ? "success" : "danger";
      };
    },
    checkStylee() {
      return (status) => {
        return status === "0" ? "info" : status === "1" ? "success" : "info";
      };
    },
    // 审核状态文字显示计算
    checkShow() {
      return (status) => {
        return status === "0"
          ? "待审核"
          : status === "1"
          ? "审核通过"
          : "审核不通过";
      };
    },
  },
};
